export default __webpack_public_path__ + "static/logo_e-3c684c125403c29fa5981b595d16ff3e.png";